module.exports = __webpack_public_path__ + "img/item8.0ca9b5da.png";